import { lighten } from "@mui/material";
import { Autocomplete } from "@mui/material";
import styled from "@emotion/styled";

export const CustomAutoComplete = styled(Autocomplete)(({ theme }) => ({
  "&.MuiAutocomplete-root .Mui-disabled": {
    //@ts-ignore
    backgroundColor: theme.appColors.surfaceContainer,
    //@ts-ignore
    color: theme.appPalette.neutral[30],
    //@ts-ignore
    // WebkitTextFillColor: lighten(theme.appColors.blackText, 0.4),
  },
}));

export default CustomAutoComplete;
